export { default } from './subhero-image'
